function initMap() {
    // The location of Uluru
    var pinLocation = {lat: 47.208031, lng: 9.5021123};
    // The map, centered at Uluru
    var map = new google.maps.Map(document.getElementById('map'), {zoom: 17, center: pinLocation});
    // The marker, positioned at Uluru
    var marker = new google.maps.Marker({position: pinLocation, map: map});
}